import { useLang, type Lang } from "../lib/i18n";
import { cx } from "./ui";

const OPTIONS: { value: Lang; label: string }[] = [
  { value: "en", label: "English" },
  { value: "hi", label: "हिंदी" },
];

/** English | हिंदी switch. Both labels stay visible so the current language is never a guess. */
export function LangToggle({ light, className }: { light?: boolean; className?: string }) {
  const { lang, setLang } = useLang();
  return (
    <div
      role="group"
      aria-label="Language / भाषा"
      className={cx("inline-flex shrink-0 items-center rounded-full border p-0.5", light ? "border-white/30" : "border-ink-200 bg-white", className)}
    >
      {OPTIONS.map((o) => {
        const active = lang === o.value;
        return (
          <button
            key={o.value}
            type="button"
            lang={o.value}
            aria-pressed={active}
            onClick={() => setLang(o.value)}
            className={cx(
              "cursor-pointer rounded-full px-2.5 py-1 text-[12.5px] font-semibold leading-none transition-colors",
              active ? (light ? "bg-white text-ink-900" : "bg-ink-900 text-white") : light ? "text-white/80 hover:text-white" : "text-ink-500 hover:text-ink-900",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
